import React from "react";
import { useIntl } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";
import ExportButton from "../../app/generic/exportButton";
import SelectAllButton from "../../app/generic/selectAllButton";
import { exportEntities } from "../../../modules/prints/pdfExport";
import FilterButton from "../../app/generic/tableFilter/filterButton";
import { exportInvoiceDataToExcel } from "../../../modules/prints/excelWork";

const InvoiceListHeader = ({
  invoices,
  showFilter,
  allSelected,
  workInvoices,
  onSelectClick,
  onFilterClick,
  disabledOptions,
}) => {
  const intl = useIntl();
  return (
    <TableHeader
      title={intl.formatMessage({
        id: "invoice.list",
        defaultMessage: "Seznam faktur",
      })}
      left={
        <span>
          <SelectAllButton allSelected={allSelected} onClick={onSelectClick} />
          <FilterButton showFilter={showFilter} onClick={onFilterClick} />
        </span>
      }
      right={
        <ExportButton
          entity={intl.formatMessage({
            id: "invoice.errorName",
            defaultMessage: "faktury",
          })}
          text={intl.formatMessage({
            id: "invoice.export",
            defaultMessage: "Export faktur",
          })}
          entities={invoices}
          disabled={disabledOptions}
          workEntities={workInvoices}
          entitiesToPdf={exportEntities}
          entitiesToExcel={exportInvoiceDataToExcel}
        />
      }
    />
  );
};

export default InvoiceListHeader;
